<ng-container [ngSwitch]="variant">
  <div *ngSwitchCase="'toggle'">
    <label id="toggle-left" class="toggle-label-left" [class.disabled]="disabled" [class.checked]="!checked" [class.toggle-select]="toggleSelect">
      {{ leftLabel }}
    </label>
    <label class="switch" [ngClass]="{ 'toggle-select': toggleSelect }">
      <input type="checkbox" name="toggle" id="toggle" [disabled]="disabled" [checked]="checked" (change)="onToggleChange($event)" tabindex="0" />
      <span class="slider round"></span>
    </label>
    <label id="toggle-right" class="toggle-label-right" [class.disabled]="disabled" [class.checked]="checked" [class.toggle-select]="!toggleSelect">
      {{ rightLabel }}
    </label>
  </div>

  <div *ngSwitchCase="'tabs'" class="tab-control rounded-lg flex relative skeleton-item">
    <div class="tab-content">
      <div class="w-full skeleton-hide">
        <div class="tab-buttons">
          <button type="button" class="tab-button" [class.selected]="!checked" [disabled]="disabled" (click)="onTabSelect('left')">
            {{ leftLabel }}
          </button>
          <button type="button" class="tab-button" [class.selected]="checked" [disabled]="disabled" (click)="onTabSelect('right')">
            {{ rightLabel }}
          </button>
        </div>
      </div>
    </div>
    <div
      class="tab-indicator"
      [ngStyle]="{
        transform: 'translateX(' + (checked ? '100%' : '0%') + ')'
      }"></div>
  </div>
</ng-container>
